import { CONSTANTS } from 'components/shared/constants';

export const showQFormSignature = (type: string) => {
  return type !== CONSTANTS.Q_FORM_TYPE.IB;
};
